
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import { SetTerminplaetzeLoaders, SetTerminplaetzeDialogs } from '@/store/terminplaetze';
    import { DataTableHeaders } from '@/types';
    import {Terminplatz} from '@/types/Terminkalender';
    import TerminplaetzeDetail from '@/components/Terminplaetze/TerminplaetzeDetail.vue';

    @Component({
        components: {
            TerminplaetzeDetail,
        },
        methods: {
            ...mapActions('terminplaetze', ['loadTerminplaetze']),
            ...mapMutations('terminplaetze', ['setDialogs']),
        },
        computed: {
            ...mapState('terminplaetze', ['terminplaetze', 'dialogs', 'loaders']),
        },
    })
    export default class Terminplaetze extends Vue {
        public loadTerminplaetze!: (payload?: SetTerminplaetzeLoaders) => void;
        public setDialogs!: (payload: SetTerminplaetzeDialogs) => void;

        public terminplatz = new Terminplatz();
        public search = '';

        public get headers(): DataTableHeaders<Terminplatz> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Terminplatz Nr.', value: 'platznr' },
                { text: 'Terminplatz', value: 'beschriftung' },
            ];
        }

        public mounted(): void {
            this.loadTerminplaetze();
        }

        public onChangeFilter(): void {
            this.loadTerminplaetze();
        }

        public onClickEditTerminplatz(terminplatz: Terminplatz): void {
            this.terminplatz = new Terminplatz(terminplatz);
            this.setDialogs({ edit: true });
        }

        public onClickNewTerminplatz(): void {
            this.terminplatz = new Terminplatz();
            this.setDialogs({ edit: true });
        }
    }
